import { Footer } from 'app/core/footer/Footer';
import { Header } from 'app/core/header/Header';
import React, { useContext } from 'react';
import { AlertBox, Column, Layout, Link, Loader, LocaleContext, Row } from 'shared';
import { useQuery } from 'shared/hooks';

import { ActivateEmailWrapper } from './ActivateEmail.styles';
import { ActivateEmailProps } from './ActivateEmail.types';

export const ActivateEmail = ({ onActivateEmail }: ActivateEmailProps) => {
  const localeContext = useContext(LocaleContext);
  const { loading, response, error } = useQuery(onActivateEmail);

  if (loading) {
    return <Loader fullScreen={true} />;
  }

  return (
    <Layout header={<Header />} footer={<Footer />}>
      <Row height="100%">
        <Column>
          <ActivateEmailWrapper className="activate-email">
            <Row height="100%">
              <Column size={[0, 3, 4]} />
              <Column size={[12, 6, 4]} className="activate-email__content">
                {response && (
                  <AlertBox
                    type={AlertBox.types.SUCCESS}
                    title={localeContext.formatMessage({ id: 'ACTIVATE-EMAIL.SUCCESS.TITLE' })}
                  >
                    {localeContext.formatMessage({ id: 'ACTIVATE-EMAIL.SUCCESS.CONTENT' })}
                    <br />
                    <Link
                      url="/login"
                      className="activate-email__login"
                      label={localeContext.formatMessage({ id: 'ACTIVATE-EMAIL.SUCCESS.CONTENT-2' })}
                    />
                  </AlertBox>
                )}
                {error && (
                  <AlertBox
                    type={AlertBox.types.FAIL}
                    title={localeContext.formatMessage({ id: 'ACTIVATE-EMAIL.FAIL.TITLE' })}
                  >
                    {localeContext.formatMessage({ id: 'ACTIVATE-EMAIL.FAIL.CONTENT' })}
                  </AlertBox>
                )}
              </Column>
              <Column size={[0, 3, 4]} />
            </Row>
          </ActivateEmailWrapper>
        </Column>
      </Row>
    </Layout>
  );
};
